
<script>

import gsap from "gsap"

export default {

  name: 'Lines',
  render: h => h(),
  data: ()=>({
    // line_size: .0075,
    line_size: .0075,
    line_color: 0xdb2000,
    lines: 0,
    is_completed: 0,
    max: 18,
    // order: [ 7, 5, 3, 1, 17, 13, 12, 14, 13, 12, 11, 10, 9, 8, 6, 4, 2, 0 ]
    // order: [ 17, 16, 15, 14, 5, 4, 3, 13, 12, 11, 10, 9, 8, 7, 6, 2, 1, 0 ]
    // order: [ 8, 5, 17, 16, 15, 14, 4, 3, 13, 12, 11, 10, 9, 7, 6, 2, 1, 0 ]
    order: [ 7, 5, 3, 1, 17, 16, 15, 14, 13, 12, 11, 10, 9, 8, 6, 4, 2, 0 ]
    // current: 11
  }),
  computed: {
    status() { return this.$store.getters['app/status'] }
  },
  watch: {
    status(nw) {

      // if(nw == 'weave_lines') {
      //   this.is_completed = 0
      //   for (let i = 0; i < this.max; i++) {
      //     this.addMotionParticules(i)
      //   }
      // }

      if(nw == 'weave_one')
        gsap.delayedCall(1.75, ()=>this.addMotionParticules(this.lines)) 
    },

    '$route': {
      immediate: true,
      handler() {
        if(this.$root.route.from.params.section == 'weave'){
          this.$store.commit('app/UPDATE_STATUS', 'completed') 
          // this.max = 0
        }
      }
    }

  },

  mounted() {

    // console.log('Lines');

    this.$store.commit('app/UPDATE_LINE', 0)
    this.$scene = this.$parent.$scene
    this.$model = this.$parent.$model
    this.$entry = this.$parent.$entry
    this.$right = this.$parent.$right
    this.resetPoints()

    // this.$tints = [ 0x008D0C, 0xDB2100, 0x3211BD, 0xDE00C3, 0x009DC7, 0x377E7A, 0xABE900, 0xFF7700, 0xEFE200, 0xB8A331, 0xFF9E7D, 0xFEF5DB ]

    this.$tints = [ 0x79187C, 0xa9c53d, 0xf39ced, 0xe47918, 0x7e54bc, 0xb81516, 0xe8f0b7,  0x0e128d, 0xef29f3, 0xb7e0e6, 0xf2e408, 0x1b24d9, 0x529a15, 0xeccb76, 0x79187C, 0xa9c53d, 0xf39ced, 0xe47918 ]
    this.$tint = 0
    this.$meshes = this.$parent.meshes

  },

  methods:{

    touchScreen(nw) {
      if(nw == true){
        this.$parent.cues = []
      }
      else  {
        // this.lines += 1   

        this.$store.commit('app/UPDATE_LINE', this.lines)
        this.updateTint()
        gsap.delayedCall(1.5, ()=>{
          if(this.lines <= this.max){
            this.$store.commit('app/WEAVE_BUTTON', 'show')
            this.$store.commit('app/UPDATE_STATUS', 'weave_completed')
          }
          if(this.lines == this.max)
            this.$store.commit('app/UPDATE_STATUS', 'continue') 
        }) 
      }
    },

    reset() {
      this.lines = 0 
      this.eraseLines()
    },

    resetPoints() {
      this.$points = []
      this.$points[0] = []
      this.$points[1] = []
      this.$points[2] = []
    },

    eraseLines() {
      this.$parent.cues = []
      this.clearAllHelpers(this.$scene)
    },

    clearAllHelpers(scene) {
      this.resetPoints()
      for (let i = 0; i < this.max; i++) {
        if(this['$tube_'+ i])
          scene.remove(this['$tube_'+ i])
      }
    },

    eraseLine() {
      this.$parent.cues = []
      this.clearHelpers(this.$scene)
    },

    getCue() {
      const wdp = this.$helper.getWorldPosition()
      return new THREE.Vector3(wdp.x, wdp.y, wdp.z)
    },

    clearHelpers(scene) {
      this.$points[this.lines] = []
      if(this['$tube_'+ this.lines])
        scene.remove(this['$tube_'+ this.lines])
    },

    addLineSegment() {
      this.clearHelpers(this.$scene)
      _.each(this.$parent.cues, (p, i)=>{
        if(i==0 || i%20 == 0 || i==this.$parent.cues.length-1)
          this.$points[this.lines].push(new THREE.Vector3(p.x, p.y, p.z))
      })
      this.onLineSegment(this.lines)
    },

    onLineSegment(line) {

      const positions = []
      const colors = []
      const spline = new THREE.CatmullRomCurve3( this.$points[line] )
      const divisions = Math.round( 20 * this.$points[line].length )
      const point = new THREE.Vector3()
      const color = new THREE.Color()

      this.$divisions = divisions

      for ( let i = 0, l = divisions; i < l; i ++ ) {
        const t = i / l
        spline.getPoint( t, point )
        positions.push( point.x, point.y, point.z )
        // color.setHSL( t, 1.0, 0.5 )
        // colors.push( color.r, color.g, color.b )
      }

      const geometry = new THREE.LineGeometry()
            geometry.setPositions( positions )

      let matLine = new THREE.LineMaterial( {
        wireframe: false,
        color: this.$tints[line],
        linewidth: .0045,
        toneMapped: true
      })

      this['$tube_'+ line] = new THREE.Line2( geometry, matLine )
      this['$tube_'+ line].computeLineDistances()
      this['$tube_'+ line].scale.set( 1, 1, 1 )
      this.$scene.add( this['$tube_'+ line] )

      // console.log(this['$tube_'+ line].material);
    },
    
    updateTint() {
      this.$tint += 1
      if(this.$tint == this.$tints.length)
        this.$tint = 0
    },

    completeMotion(spline, divisions, line) {

      // console.log('completeMotion');

      const range = 1
      const cue = { x: 0 }

      gsap.to(cue, { 
        x: divisions-range ,
        duration: 1,
        ease: 'none',
        onUpdate: ()=>{

          this.$scene.remove(this['$tube_'+ line])
          
          const pos = Math.floor(cue.x)
          const positions = []
          const point = new THREE.Vector3()
          const max = pos+(range-1)

          for ( let i = 0, l = divisions; i < l; i ++ ) {
            const t = i / l
            if(i>=pos) {
              spline.getPoint( t, point )
              positions.push( point.x, point.y, point.z )
            }
          }

          const geometry = new THREE.LineGeometry()
                geometry.setPositions( positions )
          
          let matLine = new THREE.LineMaterial( {
            wireframe: false,
            color: this.$tints[line],
            linewidth: .0045,
            toneMapped: true
          })

          this['$tube_'+ line] = new THREE.Line2( geometry, matLine )
          this['$tube_'+ line].computeLineDistances()
          this['$tube_'+ line].scale.set( 1, 1, 1 )
          this.$scene.add(this['$tube_'+ line])
        },
        onComplete: ()=>{


          this.lines += 1

          // this.is_completed += 1

          // if(this.is_completed == this.max)
          //   gsap.delayedCall(.5, ()=> this.$router.push({ params: { section: 'story' } }))

          // this.lines += 1  
          // this.updateTint()

          // gsap.delayedCall(1, ()=>{

          //   console.log('onComplete');

          //   this.$store.commit('app/WEAVE_BUTTON', 'show')
          //   this.$store.commit('app/UPDATE_STATUS', 'weave_completed')

          //   console.log('-');


          //   if(this.lines == this.max)
          //     this.$store.commit('app/UPDATE_STATUS', 'continue') 
          // }) 

        }
      })
    },

    addMotionParticules(line) {

      console.log('==== '+ line);
      const o1 = this.$meshes[this.order[line]]

      // console.log(o1.name);
      // const o2 = this.$meshes[this.order[line+1]]

      o1.material.transparent = true
      o1.material.opacity = 0

      this.$nextTick(()=>{
        o1.visible = true
      })

      gsap.to([ o1.material ],{ 
          duration: .25, 
          opacity: 1, 
          ease: 'none', 
          delay: .25, 
          onComplete: ()=>{
            o1.material.transparent = false
            // o1.visible = false
          }
      })

      const wdp = line%2 == 0 
                ? this.$entry.getWorldPosition()
                : this.$right.getWorldPosition()

      const pts = line%2 == 0 
                ? [ { x: wdp.x, y: wdp.y, z: wdp.z - (line*.035) },
                    { x: wdp.x + .03, y: wdp.y, z: wdp.z - (line*.035) },
                    { x: wdp.x + .0390, y: wdp.y, z: wdp.z - (line*.035) },
                  ]
                : [ { x: wdp.x, y: wdp.y, z: wdp.z - (line*.035) },
                    { x: wdp.x - .03, y: wdp.y, z: wdp.z - (line*.035) },
                    { x: wdp.x - .0390, y: wdp.y, z: wdp.z - (line*.035) },
                  ]

      this.$scene.remove(this['$tube_'+ line])

      // this.$points[line] = []

      _.each(pts, (pt)=>{
        this.$points[line].push(new THREE.Vector3(pt.x, pt.y, pt.z))
      })

      const colors = []
      const spline = new THREE.CatmullRomCurve3( this.$points[line] )
      const divisions = Math.round( 20 * this.$points[line].length )

      let range = this.$divisions

      const cue = { x: 0 }
      gsap.to(cue, { 

        x: divisions-range ,
        duration: .5,
        ease: 'none',
        onUpdate: ()=>{

          this.$scene.remove(this['$tube_'+ line])
          
          const pos = Math.floor(cue.x)
          const positions = []
          const point = new THREE.Vector3()
          const max = pos+(range-1)

          for ( let i = 0, l = divisions; i < l; i ++ ) {
            const t = i / l
            if(i<=max) {
              spline.getPoint( t, point )
              positions.push( point.x, point.y, point.z )
            }
          }

          const geometry = new THREE.LineGeometry()
                geometry.setPositions( positions )
          
          let matLine = new THREE.LineMaterial( {
            wireframe: false,
            color: this.$tints[line],
            linewidth: .0045,
            toneMapped: true
          })

          this['$tube_'+ line] = new THREE.Line2( geometry, matLine )
          this['$tube_'+ line].computeLineDistances()
          this['$tube_'+ line].scale.set( 1, 1, 1 )
          this.$scene.add(this['$tube_'+ line])

        },
        onComplete: ()=>{
          this.completeMotion(spline, divisions, line)   
        }
      })

    },
  }

}
</script>

<style lang="stylus">


